import { FeatureAppLoader } from '@feature-hub/react';
import { CloseHandleV2, LayerManagerV24 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { OneFormAction } from '.';

export interface OneFormState {
	featureApp: any;
	action: OneFormAction;
	params: any;
}

export const formLoader = (state: OneFormState, close: CloseHandleV2<any, any>): JSX.Element => {
	return (
			<FeatureAppLoader
				{...state.featureApp}
				featureAppId={`${state.featureApp.name}:oneform`}
				done={() => {
					close({},{},{}); // Cerramos Alert Layer contenedor al finalizar OneForm
				}}
				beforeCreate={(env) => {
					if (env.featureServices['fa-content-service']) {
						env.featureServices['fa-content-service'].content = {
							featureApp: 'action',
							action: state.action,
							carlines: state.params.carlines
						};
					}
					if (env.featureServices['api-key-provider']) {
						env.featureServices['api-key-provider'].apiKey = state.featureApp.apiKey;
					}
				}}
			/>
	);
};

export function formLoad(featureApp: any, action: OneFormAction, params: any, layerManager: LayerManagerV24) {
	if (params.carlines && !Array.isArray(params.carlines)) params.carlines=[params.carlines];
	const layerHandle = layerManager.openAlert( // Abrimos un Alert Layer para anclar el componente formLoader
		formLoader,
		{
			featureApp: featureApp,
			action: action,
			params: params
		},
		{
			userCloseable: true
		},
	);

	return layerHandle;
}
